export default __webpack_public_path__ + "9831322a9fba59023b673d894bb48fbb.png";